class ArtikelInformationen extends HTMLElement {
    connectedCallback() {
        this.initShowMore();
    }

    initShowMore() {
        this.showMoreButton = this.querySelector('[interaction="weitere-anzeigen"]');
        if (this.showMoreButton === null) return;

        this.showMoreButton.addEventListener('click', (event) => {
            const { target } = event;
            let isShowAll = target.closest(".autoren-wrapper").classList.toggle("showAll");
            if (isShowAll) {
                target.textContent = "- weniger";
            } else {
                target.textContent = "+ weitere";
            }
        })
    }
}

if (!customElements.get("artikel-informationen")) {
    customElements.define("artikel-informationen", ArtikelInformationen);
}